// extracted by mini-css-extract-plugin
export default {"like":"Like_like__gWLRE","numlike":"Like_numlike__m0wBb"};